var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChallenges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 200,
    viewBox: "0 0 140 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M94.2938 155.529C119.536 155.529 140 135.066 140 109.824C140 84.5809 119.536 64.1177 94.2938 64.1177C69.0511 64.1177 48.5879 84.5809 48.5879 109.824C48.5879 135.066 69.0511 155.529 94.2938 155.529Z",
    fill: "#0999B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M109.117 29.5293C117.076 29.5293 123.529 23.077 123.529 15.1176C123.529 7.15818 117.076 0.705811 109.117 0.705811C101.157 0.705811 94.7051 7.15818 94.7051 15.1176C94.7051 23.077 101.157 29.5293 109.117 29.5293Z",
    fill: "#4EB072"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    y: 52.2122,
    width: 125.932,
    height: 30.461,
    transform: "rotate(-11.9044 0 52.2122)",
    fill: "#FFB097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M78.648 200C103.435 200 123.53 180.089 123.53 155.529L33.7656 155.529C33.7656 180.089 53.8611 200 78.648 200Z",
    fill: "#F8815C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallenges);
export default __webpack_public_path__ + "static/media/Challenges.1d7d80ecf3547d1fc0256153eb5d3907.svg";
export { ForwardRef as ReactComponent };